<template>
  <div>
    <navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from "@/components/stage-guide/Navbar";

export default {
  components: {
    Navbar
  }
};
</script>
